"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.subjectConfig = void 0;
var enums_1 = require("../shared/enums");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.subjectConfig = (_a = {},
    _a[enums_1.BrandEnum.MONARCH] = (_b = {},
        _b[enums_1.SubjectEnum.BIBLE] = '#7686c5',
        _b[enums_1.SubjectEnum.GEOGRAPHY] = '#8dc740',
        _b[enums_1.SubjectEnum.LANGUAGE_ARTS] = '#fcb13b',
        _b[enums_1.SubjectEnum.MATH] = '#f37c7c',
        _b[enums_1.SubjectEnum.SCIENCE] = '#2ab5cd',
        _b[enums_1.SubjectEnum.ELECTIVES] = '#7b52a3',
        _b),
    _a[enums_1.BrandEnum.CALVERT] = (_c = {},
        _c[enums_1.SubjectEnum.ELECTIVES] = '#7b52a3',
        _c[enums_1.SubjectEnum.GEOGRAPHY] = '#5ca446',
        _c[enums_1.SubjectEnum.LANGUAGE_ARTS] = '#f8b830',
        _c[enums_1.SubjectEnum.MATH] = '#d64757',
        _c[enums_1.SubjectEnum.SCIENCE] = '#007abc',
        _c),
    _a);
